var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.starOutlined{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "starOutlined",
    d: "M14.96,6.37c-0.09-0.27-0.32-0.47-0.61-0.51l-3.93-0.57L8.67,1.72c-0.25-0.51-1.09-0.51-1.35,0L5.57,5.28 L1.64,5.85C1.36,5.9,1.12,6.09,1.04,6.37C0.95,6.64,1.02,6.94,1.23,7.13L4.07,9.9L3.4,13.82c-0.05,0.28,0.07,0.57,0.3,0.73 c0.23,0.17,0.54,0.19,0.79,0.06L8,12.76l3.51,1.85c0.11,0.06,0.23,0.09,0.35,0.09c0.16,0,0.31-0.05,0.44-0.14 c0.23-0.17,0.35-0.45,0.3-0.73l-0.67-3.91l2.84-2.77C14.98,6.94,15.05,6.64,14.96,6.37z M10.6,9.11c-0.18,0.17-0.26,0.42-0.22,0.66 l0.48,2.8l-2.52-1.32c-0.1-0.06-0.22-0.09-0.34-0.09s-0.24,0.03-0.35,0.09l-2.52,1.32l0.48-2.8C5.66,9.53,5.58,9.28,5.4,9.11 L3.36,7.12l2.81-0.41C6.42,6.68,6.63,6.52,6.74,6.3L8,3.75L9.26,6.3c0.11,0.22,0.32,0.37,0.57,0.41l2.81,0.41L10.6,9.11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarOutlined);
export default __webpack_public_path__ + "static/media/icon_star-outlined.8d884017f553ba62ed4a2df916633ee9.svg";
export { ForwardRef as ReactComponent };